import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';
  isLogin = false;

  constructor(
    private router: Router) {
    var isLogin = localStorage.getItem('isLogin');
    if (isLogin == 'true') {
      this.isLogin = true;
    }
  }
}
